{
  "version": 1,
  "asset_id": "3bc1cbcf-9cae-4b23-8a3c-8f1ba954840d",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/3bc1cbcf-9cae-4b23-8a3c-8f1ba954840d/lap-band-diagram-480.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/3bc1cbcf-9cae-4b23-8a3c-8f1ba954840d/lap-band-diagram-480.webp",
  "original_filename": "lap-band-diagram-480.webp",
  "size": 12764,
  "content_type": "image/webp",
  "created_at": "2026-10-04T16:12:56Z"
}
